/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MembershipDefinitions {
    angular.module("meevo.plugins.membershipDefinitions", []);
}